import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=2dd9c548&scoped=true&"
import script from "./Color.vue?vue&type=script&lang=js&"
export * from "./Color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9c548",
  null
  
)

export default component.exports